import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class UpdateCurrentAccountByClientByCarrierCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdateCurrentAccountByClientByCarrierCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl =
    'carriers/{carrierUserId}/passenger/{passengerUserId}/checkingAccount';
  override _canAddCustomHeaders = false;
  override _needAuthenticate = true;
  public override setParameters(
    parameters: IUpdateCurrentAccountByClientByCarrierCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerUserId}',
      parameters.passengerUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateCurrentAccountByClientByCarrierCommandParameters
  extends ICommandParameters {
  isActive: boolean;
  exceedingLimit: boolean;
  limit: number;
  passengerUserId: number;
  carrierUserId: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IUpdateCurrentAccountByClientByCarrierResponse
  extends ICommandResponse {}
